<ion-card class="dashboard-card">
  <ion-card-header>
    <div class="icon"><img [src]="'/assets/icon/chart-mark.svg'" [alt]="'chart-mark'" /></div>
    <ion-card-title>{{ "__CALLS_PERFORMANCE__" | translate }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ "__CALLS_AVG_FIRST_SCORE__" | translate }}</div>
        <div class="item-value">
          {{ statistic.firstScore | number: '1.2-2' }}%
        </div>
      </div>
      <ion-progress-bar [color]="getProgressColor(statistic.firstScore)" [value]="statistic.firstScore / 100"></ion-progress-bar>
    </div>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ "__CALLS_AVG_SCORE__" | translate }}</div>
        <div class="item-value">
          {{ statistic.avgScore | number: '1.2-2' }}%
        </div>
      </div>
      <ion-progress-bar [color]="getProgressColor(statistic.avgScore)" [value]="statistic.avgScore / 100"></ion-progress-bar>
    </div>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ "__CALLS_AVG_BEST_SCORE__" | translate }}</div>
        <div class="item-value">
          {{ statistic.bestScore | number: '1.2-2' }}%
        </div>
      </div>
      <ion-progress-bar [color]="getProgressColor(statistic.bestScore)" [value]="statistic.bestScore / 100"></ion-progress-bar>
    </div>
  </ion-card-content>
</ion-card>

<ion-card class="dashboard-card">
  <ion-card-header>
    <div class="icon"><img [src]="'/assets/icon/chart-growth.svg'" [alt]="'chart-growth'" /></div>
    <ion-card-title>{{ "__CALLS_IMPROVEMENT__" | translate }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ "__CALLS_AVG_IMPROVEMENT__" | translate }} <span class="sub-text">{{ "__CALLS_FIRST_VS_AVG__" | translate }}</span></div>
        <div class="item-value">
          {{ statistic.improvement | number: '1.2-2' }}%
        </div>
      </div>
      <ion-progress-bar [color]="'dark'" [value]="statistic.improvement / 100"></ion-progress-bar>
    </div>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ userType === 'manager' ? 'Team' : ''}} {{ "__CALLS_CONSISTENCY_GAP__" | translate }} <span class="sub-text">{{ "__CALLS_BEST_VS_AVG__" | translate }}</span></div>
        <div class="item-value">
          {{ statistic.consistencyGap | number: '1.2-2' }}%
        </div>
      </div>
      <ion-progress-bar [color]="'dark'" [value]="statistic.consistencyGap / 100"></ion-progress-bar>
    </div>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ "__CALLS_PERFORMANCE_IMPROVEMENT__" | translate }} <span class="sub-text">{{ "__CALLS_FIRST_VS_BEST__" | translate }}</span></div>
        <div class="item-value">
          {{ (statistic.performanceImprovement) | number: '1.2-2' }}%
        </div>
      </div>
      <ion-progress-bar [color]="'dark'" [value]="statistic.performanceImprovement / 100"></ion-progress-bar>
    </div>
  </ion-card-content>
</ion-card>

<ion-card class="dashboard-card">
  <ion-card-header>
    <div class="icon"><img [src]="'/assets/icon/clock-mark.svg'" [alt]="'clock-mark'" /></div>
    <ion-card-title>{{ "__CALLS_EFFICIENCY__" | translate }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="item-wrapper">
      <div class="item border-bottom">
        <div class="item-title">{{ "__CALLS_AVG_ATTEMPTS_PER_SCORECARD__" | translate }}</div>
        <div class="item-value">
          {{ statistic.totalAttempts ? (statistic.totalAttempts | number: '1.2-2') : '-' }}
        </div>
      </div>
    </div>
    <div class="item-wrapper">
      <div class="item border-bottom">
        <div class="item-title">{{ "__CALLS_AVG_DEVELOPMENT_TIME__" | translate }}</div>
        <div class="item-value">
          {{ statistic.totalDuration ? (statistic.totalDuration | floor | number: '1.0-0') : '0' }} min
          {{ statistic.totalDuration ? ((statistic.totalDuration * 60) % 60 | floor | number: '2.0-0') : '0' }} sec
        </div>
      </div>
    </div>
    <div class="item-wrapper">
      <div class="item border-bottom">
        <div class="item-title">{{ "__CALLS_AVG_TIME_TO_MASTERY__" | translate }}</div>
        <div class="item-value">
          {{ statistic.timeToMastery ? (statistic.timeToMastery | floor | number: '1.0-0') : '0' }} min
          {{ statistic.timeToMastery ? ((statistic.timeToMastery * 60) % 60 | floor | number: '2.0-0') : '0' }} sec
        </div>
      </div>
    </div>
    <div class="item-wrapper">
      <div class="item">
        <div class="item-title">{{ "__CALLS_AVG_ATTEMPTS_TO_MASTERY__" | translate }}</div>
        <div class="item-value">
          {{ statistic.attemptToMastery ? (statistic.attemptToMastery | number: '1.2-2') : '-' }}
        </div>
      </div>
    </div>
  </ion-card-content>
</ion-card>
